var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit2 = function SvgEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.759 1.988a3.255 3.255 0 0 1 3.253 3.253c0 .863-.343 1.691-.953 2.301L8.496 20.106a2.5 2.5 0 0 1-1.03.618h-.001l-4.097 1.242h-.002a1.07 1.07 0 0 1-1.333-1.331v-.003l1.244-4.096v-.002c.12-.389.333-.743.62-1.03L16.46 2.94l.116-.11a3.25 3.25 0 0 1 2.184-.842m0 1.2c-.544 0-1.067.215-1.452.6L4.747 16.354h-.002a1.3 1.3 0 0 0-.32.532l-1.173 3.86 3.864-1.17c.201-.062.384-.171.533-.32L20.21 6.694a2.054 2.054 0 0 0-1.451-3.505"
  })));
};
export default SvgEdit2;